module.exports = __webpack_public_path__ + "static/media/wardah_brand_banner.6194daca.jpg";